module.exports = __webpack_public_path__ + "_assets/img/bell.0a0145b6.svg";